import {
  Provider as OffersHistoryProvider,
  OffersHistoryContainerDesktop as OffersHistoryContainer,
} from '../../../../../packages/OffersHistory';
import { useSelector } from 'react-redux';
import { Section } from 'shared/components/Section';
import { selectOffersHistory, selectOffersHistorySpoilerDataExists } from 'shared/selectors/offersHistory';
import { useOffersHistoryActions } from '../../hooks';
import { FC } from 'react';

export const OffersHistoryDesktopContainer: FC = () => {
  const offersHistory = useSelector(selectOffersHistory);
  const isSpoilerDataExists = useSelector(selectOffersHistorySpoilerDataExists);
  const actions = useOffersHistoryActions();

  if (!isSpoilerDataExists) {
    return null;
  }

  return (
    <Section title="История объявлений в этом доме">
      <OffersHistoryProvider {...offersHistory} {...actions}>
        <OffersHistoryContainer />
      </OffersHistoryProvider>
    </Section>
  );
};
